module.exports = __webpack_public_path__ + "img/loader.131d0063.gif";